import { MineIcon, PlusIcon } from "assets/icons";

function FoodCard({ data }) {
  return (
    <div className="w-full sm:max-w-[254px] flex flex-col">
      <div
        style={{ backgroundImage: `url(${data.image})` }}
        className="bgImage !h-[150px] rounded-[10px]"
      />
      <div className="w-full flex flex-col items-center p-5 gap-2.5">
        <div className="text-sm text-center font-medium text-[#202020]">
          {data.label}
        </div>
        <div className="text-base text-[#202020] font-semibold">{`RM ${data.price}`}</div>
        {data.price === 10 ? (
          <div className="flex items-center">
            <button className="h-6 w-6 border-[1px] border-primary-700 rounded-[4px] flex items-center justify-center">
              <MineIcon />
            </button>
            <div className="text-sm font-semibold text-[#202020] px-4">2</div>
            <button className="h-6 w-6 border-[1px] border-primary-700 rounded-[4px] flex items-center justify-center">
              <PlusIcon />
            </button>
          </div>
        ) : (
          <button className="w-[80px] h-[32px] border-[1px] border-primary-700 rounded-[10px] text-sm font-medium">
            Add
          </button>
        )}
      </div>
    </div>
  );
}
export default FoodCard;
